import axiosInstance from '../AxiosClient'
import { createApi, createCollectionManager, createCustomServiceCall } from '@thinknimble/tn-models'
import {
  campaignShape,
  campaignRetrieveShape,
  campaignUpdateShape,
  canvassingOrgAdminChartInputShape,
  storeCampaignDataFilterTemplateShape,
} from './models'
import { formTokenQuery } from '../formAccess'

const CAMPAIGN_ENDPOINT = '/campaigns/'
const FILTER_TEMPLATES_ENDPOINT = '/filterTemplates/'

const customRetrieve = createCustomServiceCall(
  {
    inputShape: campaignRetrieveShape,
    outputShape: campaignShape,
  },
  async ({ client, utils, input }) => {
    const params = formTokenQuery(input.formToken, input.legacyFundraiser)
    const res = await client.get(`${CAMPAIGN_ENDPOINT}${input.campaign}/${params}`)
    return utils.fromApi(res.data)
  },
)

const customUpdate = createCustomServiceCall(
  {
    inputShape: campaignUpdateShape,
    outputShape: campaignShape,
  },
  async ({ client, input, utils: { toApi, fromApi } }) => {
    const { id, ...rest } = toApi(input)
    const res = await client.patch(`${CAMPAIGN_ENDPOINT}${id}/`, rest)
    return fromApi(res.data)
  },
)

const fundraiser_count_per_campaign = createCustomServiceCall(
  {
    inputShape: canvassingOrgAdminChartInputShape,
  },
  async ({ client, input, utils: { toApi } }) => {
    const { start_date, end_date, campaign_filter_value } = toApi(input)
    const params = `?start_date=${start_date}&end_date=${end_date}&campaign_list=${campaign_filter_value}`
    const res = await client.get(`${CAMPAIGN_ENDPOINT}fundraiser_count_per_campaign/${params}`)
    return res.data
  },
)

const saveCampaignDataFilterTemplate = createCustomServiceCall(
  {
    inputShape: storeCampaignDataFilterTemplateShape,
  },
  async ({ client, input, utils }) => {
    const formattedData = utils.toApi(input)
    const response = await client.post(`${FILTER_TEMPLATES_ENDPOINT}`, formattedData)
    return response.data
  },
)

export const CampaignApi = createApi(
  {
    baseUri: CAMPAIGN_ENDPOINT,
    client: axiosInstance,
    models: {
      entity: campaignShape,
    },
  },
  { customRetrieve, customUpdate, fundraiser_count_per_campaign, saveCampaignDataFilterTemplate },
)

export const campaignFunctions = () => {
  const campaignFilters = {
    ordering: '-givaroo_id',
  }

  const campaignCollection = createCollectionManager({
    fetchList: CampaignApi.list,
    filters: campaignFilters,
  })

  return {
    campaignCollection,
    campaignFilters,
  }
}
